import React, { useEffect, useState } from "react";
import "./Sidebar.css";
import { Link} from "react-router-dom";
import db from "../../../Firebase/Firebase-config";
import { useUserAuth } from "../../../Context/UseAuthContext";
import firebase from "firebase/compat/app";

function SibarChart(props) {
  const { name, id } = props;
  const [messages, setMessages] = useState("");

  const { currentUser } = useUserAuth();

  useEffect(() => {

    if (id) {
      db.collection("rooms")
        .doc(id)
        .collection("messages")
        .orderBy("timestamp", "desc")
        .onSnapshot((snapshot) => {
          setMessages(snapshot.docs.map((doc) => doc.data()));
        });
    }
  }, [id]);

  const sendAlert = () => {

    db.collection("rooms").doc(id).collection("messages").add({
      messages: currentUser.displayName + " has joined the chat",
      name: currentUser.displayName,
      timestamp: firebase.firestore.FieldValue.serverTimestamp(),
    })
  }

  return (
    <Link to={`/dash/${id}`} onClick={sendAlert}>
      <div className="sidebarChart">
        <div className="sidebarChart__info">
          <h3>{name} </h3>
        </div>
      </div>
    </Link>
  );
}

export default SibarChart;
